import { addNotification, getSessionSaga, reduceLoading } from 'metrix-common3';
import { call, delay, put } from 'redux-saga/effects';

// Keep the success toast on screen briefly before navigating to the new cancellation transaction.
const SUCCESS_REDIRECT_DELAY = 3000;

export function* createCancellationSaga(action) {
    try {
        yield put(reduceLoading({ code: 'createCancellation', value: true }));
        const session = yield getSessionSaga();

        const response = yield call(fetch, '/api/policyCancellation/create', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                sourceTransactionGuid: action.payload.sourceTransactionGuid,
                cancellationDate: action.payload.cancellationDate,
                cancellationReasonCode: action.payload.cancellationReasonCode,
                cancellationReasonDescription: action.payload.cancellationReasonDescription,
            }),
        });

        const result = yield call([response, 'json']);

        if (result.operation?.status && result.policyTransaction?.guid) {
            yield put(
                addNotification({
                    code: 'createCancellation',
                    type: 'success',
                    message: action.payload.successMessage,
                }),
            );
            // Loading stays set across the delay so the open modal cannot submit a second cancellation.
            yield delay(SUCCESS_REDIRECT_DELAY);
            // The cancellation is a new transaction with its own guid - navigate to it.
            window.location = `/profile?entity=${result.policyTransaction.guid}`;
        } else {
            yield put(reduceLoading({ code: 'createCancellation', value: false }));
            yield put(
                addNotification({
                    code: 'createCancellation',
                    type: 'error',
                    errors: result.operation?.errors,
                    message: action.payload.errorMessage,
                }),
            );
        }
    } catch (error) {
        console.log('Error while creating Cancellation API - ', error);
        yield put(reduceLoading({ code: 'createCancellation', value: false }));
        yield put(
            addNotification({
                code: 'createCancellation',
                type: 'error',
                message: action.payload.errorMessage,
            }),
        );
    }
}
